export const SET_COVER_LETTER_INITIAL_STATE = 'SET_COVER_LETTER_INITIAL_STATE';
export const UPDATE_USER_PREFERENCES = 'UPDATE_USER_PREFERENCES_COVER_LETTER';
export const SET_UNMOUNT_DATA = 'SET_UNMOUNT_DATA_COVER_LETTER';
export const UPDATE_SECTION = 'UPDATE_COVER_LETTER_SECTION';
export const UPDATE_EXPORT = 'UPDATE_COVER_LETTER_EXPORT';
export const SET_PAGES = 'SET_COVER_LETTER_PAGES';
export const UPDATE_HISTORY = 'UPDATE_HISTORY_COVER_LETTER';
export const RESET_HISTORY = 'RESET_COVER_LETTER_HISTORY';
export const SET_COVER_LETTER_COUNTER_VALUE = 'SET_COVER_LETTER_COUNTER_VALUE';
export const SET_SAVE_STATUS = 'SET_COVER_LETTER_SAVE_STATUS';
export const SET_DRAG = 'SET_DRAG_COVER_LETTER';
export const SET_COVER_LETTER_TYPE = 'SET_COVER_LETTER_TYPE';
export const SHOW_ERROR = 'SHOW_ERROR';
export const UPDATE_EVENT_TYPES = 'UPDATE_EVENT_TYPES_COVER_LETTER';
export const SET_DRAG_OVER_CORDS = 'SET_DRAG_OVER_CORDS';
export const UPDATE_DOCUMENT_NAME = 'UPDATE_DOCUMENT_NAME';
export const UPDATE_EDITED_INPUTS = 'UPDATE_EDITED_INPUTS_COVER_LETTER';
